// src/subscreens/FeaturesSection.js
import React from 'react';
import { FaBrain, FaShareAlt, FaUsers, FaComments, FaTrophy, FaChartLine } from 'react-icons/fa';
import '../../../assets/css/home/FeaturesSection.css';

const FeaturesSection = () => {
  const features = [
    {
      icon: <FaBrain size={50} />,
      title: "AI Notes Summarization",
      description: "Automatically summarize long notes into easy, quick-to-read content using AI."
    },
    {
      icon: <FaShareAlt size={50} />,
      title: "Notes & File Sharing",
      description: "Share notes, PDFs, and study material instantly with your study circle."
    },
    {
      icon: <FaUsers size={50} />,
      title: "Easy Group Study",
      description: "Create or join study groups and collaborate with classmates effortlessly."
    },
    {
      icon: <FaComments size={50} />,
      title: "Live Interactions",
      description: "Chat and interact with group members in real time for better understanding."
    },
    {
      icon: <FaTrophy size={50} />,
      title: "Quizzes & Competitions",
      description: "Test your knowledge through quizzes and friendly competitions."
    },
    {
      icon: <FaChartLine size={50} />,
      title: "Performance Tracking",
      description: "Track your learning progress and performance over time."
    }
  ];

  return (
    <section className="fs-features-section py-5" id="features">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="fs-section-title">Our Amazing Features</h2>
         
          </div>
        </div>
        <div className="row g-4">
          {features.map((feature, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="fs-feature-card">
                <div className="fs-feature-icon">
                  {feature.icon}
                </div>
                <h4 className="fs-feature-title">{feature.title}</h4>
                <p className="fs-feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;